import React from 'react';
import { Handle, Position } from '@xyflow/react';

const iconStyle = { width: 14, height: 14, flexShrink: 0, color: 'var(--text-tertiary)' };

const TriggerTypeIcon = ({ type }) => {
  if (type === 'schedule') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={iconStyle}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    );
  }
  if (type === 'webhook') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={iconStyle}>
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <path d="M15 3h6v6" />
        <path d="M10 14L21 3" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={iconStyle}>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <polyline points="10 17 15 12 10 7" />
      <line x1="15" y1="12" x2="3" y2="12" />
    </svg>
  );
};

const TRIGGER_TYPE_LABELS = {
  manual: 'Manual',
  schedule: 'Schedule',
  webhook: 'Webhook',
};

export default function TriggerNode({ data, selected }) {
  const triggerType = data?.config?.triggerType?.trim() || 'manual';
  const typeLabel = TRIGGER_TYPE_LABELS[triggerType] ?? triggerType;

  return (
    <div
      className={data?.__animateAppear ? 'workflow-node-appear' : undefined}
      style={{
        padding: '10px 14px',
        background: 'var(--card-bg)',
        border: selected ? '2px solid #eab308' : '1px solid #eab308',
        borderRadius: '8px',
        minWidth: 120,
        boxShadow: selected ? '0 0 0 2px rgba(234, 179, 8, 0.35)' : '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4, color: 'var(--text-primary)' }}>Trigger</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: 6 }}>{data?.label ?? 'Trigger'}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.75rem', color: 'var(--text-tertiary)' }}>
        <TriggerTypeIcon type={triggerType} />
        <span>{typeLabel}</span>
      </div>
      <Handle type="source" position={Position.Right} style={{ background: '#eab308', width: 14, height: 14, borderRadius: '50%' }} />
    </div>
  );
}
